import { render, staticRenderFns } from "./nlp_phrase_page.vue?vue&type=template&id=6b3c1db4&"
import script from "./nlp_phrase_page.vue?vue&type=script&lang=js&"
export * from "./nlp_phrase_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports